const test_enabled = process.env.REACT_APP_TEST_ENABLED?.toLocaleLowerCase();
const test_mode = test_enabled === "1" || test_enabled === "y";

export default {
  isTestServer: test_mode && window.location.href.includes("test-goono"),
};
